import Css from "./style.module.scss";

import { Input } from "nlib/ui";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import React, { useCallback } from "react";

const MinAmountForAttachment = ({ value = "", disabled, onChange, ...restProps }) => {
  const { uiTexts } = useSelector(getTextsData);

  const handleChange = useCallback((val) => {
    const parsed = +val;

    onChange((isNaN(parsed) || val === "") ? val : parsed);
  }, [onChange]);

  return (
    <div className={Css.excludedWords}>
      <Input
        type="number"
        value={value}
        disabled={disabled}
        onChange={handleChange}
        placeholder={uiTexts.enterMinimalTransactionAmount}
        invalid={value === ""}
        {...restProps} />
    </div>
  );
};

export default React.memo(MinAmountForAttachment);
